import NoteTitle from "../Atoms/NoteTitle";
import NoteBody from "../Atoms/NoteBody";
import styles from "../../Styles/NoteItem.module.css";
import { motion } from "framer-motion";

const variants = {
  hidden: { opacity: 0 },
  visible: ({ delay }) => ({
    opacity: 1,
    transition: { delay: delay, duration: 1 },
  }),
};

const NoteItem = ({ title, text, selectedNote, id, index }) => {
  const selectedHandler = (noteSelected) => {
    selectedNote(noteSelected);
  };
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={variants}
      custom={{ delay: (index + 1)*0.2 }}
      layoutId={id}
      className={styles.note_item}
      onClick={() => selectedHandler({ title, text, id })}
    >
      <NoteTitle title={title} />
      <NoteBody children={text} />
    </motion.div>
  );
};
export default NoteItem;
